import logoData from "./logoData";
import priceData from "./priceData";
import StatsSection from "./StatsSection";

export default function LandingB() {
  return (
    <div className="min-h-screen bg-gradient-to-r from-[#f9f7f7] via-[#e9f5ff] to-[#d8f3e3] px-6 py-12 font-sans">
      <section className="w-full px-6 py-20  text-gray-900 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold leading-tight mb-8 flex flex-wrap items-center justify-center gap-2">
            Your personalized AI for mindfulness
          </h1>
          <div className="flex flex-col md:flex-row justify-center items-center gap-6 text-sm md:text-base font-medium mb-10">
            <span>Neuroscience-Backed Mindfulness</span>
            <span className="text-gray-600">
              Embark on a journey towards inner peace, balance and
              self-discovery.
            </span>
          </div>
          <button className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-6 py-3 rounded-full inline-flex items-center gap-2 transition">
            Get the App
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-5 h-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path d="M3 10a1 1 0 011-1h9.586l-3.293-3.293a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 11-1.414-1.414L13.586 11H4a1 1 0 01-1-1z" />
            </svg>
          </button>
        </div>
      </section>
      <StatsSection />
      <section className="px-6 py-12">
        <div className="grid md:grid-cols-2 gap-8 max-w-7xl mx-auto items-center">
          <div>
            <img
              src="https://images.unsplash.com/photo-1574158622682-e40e69881006"
              alt="tag"
              className="w-28 h-12 rounded-full object-cover"
            />
            <div className="text-5xl md:text-6xl font-bold leading-tight text-gray-900 mb-6">
              <div
                data-aos="fade-up"
                data-aos-easing="linear"
                data-aos-duration="500"
              >
                <span>AI-powered</span>
              </div>
              <div
                data-aos="fade-up"
                data-aos-easing="linear"
                data-aos-duration="600"
              >
                <span>video creation</span>
              </div>
              <div
                data-aos="fade-up"
                data-aos-easing="linear"
                data-aos-duration="700"
              >
                <span
                  data-aos="fade-up"
                  data-aos-easing="linear"
                  data-aos-duration="700"
                >
                  for your business.
                </span>
              </div>
            </div>
            <div className="mt-10 flex gap-6 items-center">
              <button className="bg-blue-100 text-black px-6 py-2 rounded-full text-sm font-medium hover:bg-blue-200 transition">
                Contact us ↗
              </button>
              <a
                href="href"
                className="text-sm font-medium underline hover:text-gray-800"
              >
                About Us
              </a>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {/* 카드 1 */}
            <div
              className="col-span-2 min-h-[25vh] rounded-3xl p-6 relative text-white bg-cover bg-center"
              style={{
                backgroundImage:
                  "url('https://images.unsplash.com/photo-1583608205776-bfd35f0d9f83?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
              }}
            >
              <h2 className="text-2xl font-semibold leading-snug mb-2">
                Real Estate
              </h2>
              <p className="text-sm opacity-90">
                Showcase properties with AI-generated tours made from your
                uploaded images.
              </p>
              <button className="absolute bottom-4 right-4 w-10 h-10 rounded-full bg-white text-black flex items-center justify-center">
                ↗
              </button>
            </div>

            {/* 카드 2 */}
            <div
              className="rounded-3xl p-6 min-h-[30vh] relative text-white bg-cover bg-center"
              style={{
                backgroundImage:
                  "url('https://images.unsplash.com/photo-1700339062616-11c7fc9a673d?q=80&w=3097&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
              }}
            >
              {/* <div className="bg-white text-black text-xs px-3 py-1 rounded-full inline-block mb-2">
              Products
            </div> */}
              <h2 className="text-2xl font-semibold leading-snug mb-2">
                Products
              </h2>
              <p className="text-sm opacity-90">
                Turn product shots into sleek promotional videos for your store
                or brand.
              </p>
              <button className="absolute bottom-4 right-4 w-8 h-8 rounded-full bg-white text-black flex items-center justify-center">
                ↗
              </button>
            </div>

            <div className="relative rounded-3xl overflow-hidden min-h-[30vh] text-white group">
              <div className="absolute inset-0 overflow-hidden opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none">
                <div className="w-full h-full scale-[3] sm:scale-[1.8] md:scale-[1.6] lg:scale-[1.4] xl:scale-[1.2] transform origin-center">
                  <iframe
                    className="w-full h-full"
                    src="https://www.youtube.com/embed/EuXawCcSFas?autoplay=1&mute=1&controls=0&loop=1&playlist=EuXawCcSFas&modestbranding=1&rel=0"
                    title="Fashion video"
                    frameBorder="0"
                    allow="autoplay; encrypted-media"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
              <div
                className="absolute inset-0 bg-cover bg-center transition-opacity duration-500 group-hover:opacity-0"
                style={{
                  backgroundImage:
                    "url('https://plus.unsplash.com/premium_photo-1707932485795-1d0aed727376?q=80&w=3135&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
                }}
              ></div>

              {/* 콘텐츠 */}
              <div className="relative z-10 p-6 flex flex-col justify-between h-full">
                <div>
                  <h2 className="text-2xl font-semibold leading-snug mb-2">
                    Fashion
                  </h2>
                  <p className="text-sm opacity-90 text-white">
                    Highlight fashion pieces in eye-catching video reels made
                    effortlessly.
                  </p>
                </div>
                <div className="flex justify-end mt-4">
                  <button className="w-8 h-8 rounded-full bg-white text-black flex items-center justify-center">
                    ↗
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className=" py-20 px-6">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-3">Plans and Pricing</h2>
          <p className="text-gray-600 mb-10">
            Receive unlimited credits when you pay yearly, and save on your
            plan.
          </p>

          {/* 요금제 카드 */}
          <div className="grid md:grid-cols-3 gap-6">
            {priceData.map((plan) => (
              <div
                key={plan.name}
                className={`rounded-2xl shadow-md p-6 bg-white ${
                  plan.highlight ? "border-2 border-indigo-600" : ""
                }`}
              >
                <h3 className="text-lg font-semibold mb-1">{plan.name}</h3>
                <p className="text-sm text-gray-600 mb-4">{plan.description}</p>
                <div className="text-3xl font-bold mb-1">{plan.price}</div>
                <p className="text-xs text-gray-500 mb-6">{plan.billed}</p>
                <button
                  className={`w-full py-2 rounded-full font-medium text-sm ${
                    plan.highlight
                      ? "bg-indigo-600 text-white hover:bg-indigo-700"
                      : "bg-gray-100 text-gray-800 hover:bg-gray-200"
                  } transition`}
                >
                  Get started
                </button>
                <ul className="text-sm mt-6 space-y-2 text-left">
                  {plan.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-2">
                      {feature.includes("not included") ? (
                        <span className="text-gray-400">✕</span>
                      ) : (
                        <span className="text-green-600">✓</span>
                      )}
                      <span
                        className={
                          feature.includes("not included")
                            ? "text-gray-400 line-through"
                            : ""
                        }
                      >
                        {feature.replace(" (not included)", "")}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section
        data-aos="fade-up"
        data-aos-easing="linear"
        data-aos-duration="500"
        className="px-6 py-16 text-center"
      >
        <p className="text-gray-700 text-sm md:text-base font-medium mb-8">
          Trusted by 50,000+ businesses to scale outbound sales and drive new
          revenue
        </p>
        <div className="flex flex-wrap justify-center items-center gap-6 md:gap-10 max-w-5xl mx-auto">
          {logoData.map((logo) => (
            <img
              key={logo.name}
              src={logo.src}
              alt={logo.name}
              className="h-6 md:h-8 object-contain"
            />
          ))}
        </div>
      </section>
    </div>
  );
}
